(function () {
  const initSectionReveal = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const elements = document.querySelectorAll('[data-reveal]:not(.is-revealed)');

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          const delay = el.dataset.revealDelay || '0';

          el.style.setProperty('--reveal-delay', `${delay}ms`);
          el.classList.add('is-revealed');
          obs.unobserve(el);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -60px 0px'
      }
    );

    elements.forEach((el) => observer.observe(el));
  };

  document.addEventListener('DOMContentLoaded', initSectionReveal);
  document.addEventListener('shopify:section:load', initSectionReveal);
  document.addEventListener('shopify:section:reorder', initSectionReveal);
})();